import { Box, Grid, Typography } from '@mui/material';
import FormsPopup from '../../common/FormsPopup/FormsPopup';
import InputField from '../../common/InputField/InputField';
import CustomSelect from '../../common/Select';
import UserAvatar from '../../common/UserAvatar/UserAvatar';
import { EditProfileProps } from './types';
import styles from './styles';
import FormButton from '../../common/FormButton';

const EditMyProfile = ({
    editProfileDetails,
    selectedRoleId,
    userInfo,
    handleSubmit,
    handleInput,
    roles,
    handleChangeAvatar,
    selectedImage,
    formErrors,
    handleCloseMyProfile,
    submitting,
}: EditProfileProps) => {
    return (
        <FormsPopup
            id="edit_profile"
            open={editProfileDetails}
            title="My Profile"
            textAlign="left"
            handleClose={() => handleCloseMyProfile(false)}
            width={662}
        >
            <Box component="form" noValidate onSubmit={handleSubmit}>
                <Grid container spacing={2}>
                    <Grid item xs={6}>
                        <UserAvatar
                            name={`${userInfo.firstname} ${userInfo.lastname}`}
                            source={
                                selectedImage ||
                                (userInfo.signedImageUrl &&
                                userInfo.signedImageUrl !== 'null' &&
                                userInfo.signedImageUrl !== 'undefined'
                                    ? userInfo.signedImageUrl
                                    : '')
                            }
                            size={279}
                            radius="16px"
                            fontSize={50}
                            isEditing
                            handleChangeAvatar={handleChangeAvatar}
                        />
                    </Grid>
                    <Grid item xs={6}>
                        <InputField
                            required
                            id="firstname"
                            label="First Name"
                            type="text"
                            name="firstname"
                            placeholder="Type here..."
                            onChange={handleInput}
                            value={userInfo.firstname}
                            error={formErrors && formErrors.firstname && formErrors.firstname[0] !== ''}
                            errorMessage={formErrors && formErrors.firstname && formErrors.firstname[0]}
                        />
                        <Typography sx={styles.profileField} component="div">
                            <InputField
                                required
                                id="lastname"
                                label="Last Name"
                                type="text"
                                name="lastname"
                                placeholder="Type here..."
                                onChange={handleInput}
                                value={userInfo.lastname}
                                error={formErrors && formErrors.lastname && formErrors.lastname[0] !== ''}
                                errorMessage={formErrors && formErrors.lastname && formErrors.lastname[0]}
                            />
                        </Typography>
                        <Typography sx={styles.profileField} component="div">
                            <CustomSelect
                                name="roleId"
                                label="Role*"
                                id="roleId"
                                handleOnchange={handleInput}
                                items={roles}
                                value={selectedRoleId}
                                disabled
                                error={formErrors && formErrors.roleId && formErrors.roleId[0] !== ''}
                                errorMessage={formErrors && formErrors.roleId && formErrors.roleId[0]}
                            />
                        </Typography>
                        <Typography sx={styles.profileField} component="div">
                            <InputField
                                required
                                id="email"
                                label="Email"
                                type="email"
                                name="email"
                                placeholder="Type here..."
                                onChange={handleInput}
                                value={userInfo.email}
                                disabled
                                error={formErrors && formErrors.email && formErrors.email[0] !== ''}
                                errorMessage={formErrors && formErrors.email && formErrors.email[0]}
                            />
                        </Typography>
                    </Grid>
                    <Grid item xs={6}>
                        <Typography sx={styles.profileField} component="div">
                            <InputField
                                required
                                id="newPassword"
                                label="New Password"
                                type="password"
                                name="password"
                                placeholder="Type here..."
                                onChange={handleInput}
                                value={userInfo.password}
                                style={{ width: 280 }}
                                error={formErrors && formErrors.password && formErrors.password[0] !== ''}
                                errorMessage={formErrors && formErrors.password && formErrors.password[0]}
                            />
                        </Typography>
                    </Grid>
                    <Grid item xs={6} sx={styles.profileField}>
                        <Typography component="div">
                            <InputField
                                required
                                id="repeatPassword"
                                label="Repeat Password"
                                type="password"
                                name="repeatPassword"
                                placeholder="Type here..."
                                onChange={handleInput}
                                value={userInfo.repeatPassword}
                                error={formErrors && formErrors.repeatPassword && formErrors.repeatPassword[0] !== ''}
                                errorMessage={formErrors && formErrors.repeatPassword && formErrors.repeatPassword[0]}
                            />
                        </Typography>
                    </Grid>
                    <Typography sx={styles.warning} component="div">
                        Requirements: Password must have at least 8 characters, including one capital letter, one
                        special character and one number and cannot be common.
                    </Typography>
                    <FormButton
                        variant="contained"
                        type="submit"
                        sx={styles.profileButton}
                        id="saveProfile"
                        fullWidth
                        submitting={submitting}
                    >
                        Save Changes
                    </FormButton>
                </Grid>
            </Box>
        </FormsPopup>
    );
};
export default EditMyProfile;
